import React from 'react';

import { useContext as useUsersContext } from 'components/Users/Context';

import { Button } from 'react-bootstrap5';

import confirmAlert from 'components/new_ui/Alerts/confirm';
import Alert from 'components/new_ui/Alerts/alert';

import Actions from './Actions';

export default function RequestDelete() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const onDeleteAccount = () => {
    confirmAlert({
      title: 'Confirm Delete Account',
      text: 'Do you want to delete your account?',
      confirmButtonText: 'Delete',
    }, () => {
      Actions.requestDelete(() => {
        actionsUsers.load(dispatchUsers);

        Alert({
          title: 'Delete Account',
          text: `We sent your request to delete your account to the LeggUP Team. 
          We may call you for additional confirmation.`,
        });
      });
    });
  };

  return (
    <div className="mt-4">
      <h4>Request to Delete</h4>
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          <p>Click the Delete button to send LeggUP Team a request to delete your LeggUP account.</p>
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-end">
            <Button
              onClick={onDeleteAccount}
              variant="outline-danger"
            >
              Delete Account
            </Button>

          </div>
        </div>
      </div>
    </div>
  );
}
